<script setup lang="ts">
  import { TStatsChartInterval } from './v2-stats-interval.types';

  const props = defineProps<{
    value: TStatsChartInterval;
  }>();

  const emit = defineEmits<{
    (e: 'input', value: TStatsChartInterval): void;
  }>();

  const OPTIONS: TStatsChartInterval[] = [
    'auto',
    'hourly',
    'daily',
    'weekly',
    'monthly',
  ];

  function onChange(event: Event) {
    const raw = (event.target as HTMLSelectElement).value;
    if (raw === props.value) return;
    emit('input', raw as TStatsChartInterval);
  }
</script>

<template>
  <label class="v2-stats-interval-select">
    <span class="interval-label">{{ $t('v2Stats.interval.label') }}</span>
    <select class="interval-select" :value="value" @change="onChange">
      <option v-for="option in OPTIONS" :key="option" :value="option">
        {{ $t(`v2Stats.interval.${option}`) }}
      </option>
    </select>
  </label>
</template>

<style scoped lang="scss">
  .v2-stats-interval-select {
    @apply tw-mb-2 tw-mr-3 tw-inline-flex tw-items-center;

    .interval-label {
      @apply tw-mr-1.5 tw-text-xs tw-font-medium tw-text-neutral-500;
    }

    .interval-select {
      @apply tw-h-11 tw-rounded-lg tw-border tw-border-solid tw-border-neutral-300 tw-bg-white tw-px-2.5 tw-text-sm tw-text-neutral-900;

      &:focus {
        @apply tw-border-orange-500 tw-outline-none tw-ring-2 tw-ring-orange-500/40;
      }
    }
  }
</style>
